import { useContext } from 'react';
import { StepsContext } from '../context/StepsContext';
import { useEffect } from 'react';

type PercentageProps = {
  total: number;
  doneHandler(condition: boolean): void;
};

const percentageComponent = (props: PercentageProps): JSX.Element => {
  const qContext = useContext(StepsContext);
  let percent = {
    current: qContext.completedSteps.indexOf(qContext.currentStep?.questionList[0].id!),
    total: props.total,
  };
  useEffect(() => {
    props.doneHandler(Math.round((100 * (percent.current! + 1)) / percent.total) === 100);
  }, [percent.total]);

  return (
    <p className="percentage-container">
      {Math.round((100 * (percent.current! + 1)) / percent.total)}% complete
    </p>
  );
};

export default percentageComponent;
